import { apiPost, apiDelete } from "@/lib/api/client";

/**
 * Thin wrappers over the places enrichment / publish endpoints, isolating the
 * raw `apiPost` / `apiDelete` calls so usePlaceEnrichment reads as control flow.
 */

export async function enrichPlace(placeId: string): Promise<any> {
  const { data } = await apiPost<any>(`/places/${placeId}/enrich`, {});
  return data;
}

export async function publishPlace(
  placeId: string,
): Promise<{ slug: string; url: string }> {
  const { data } = await apiPost<{ slug: string; url: string }>(
    `/places/${placeId}/publish`,
    {},
  );
  return data;
}

export async function unpublishPlace(placeId: string): Promise<void> {
  await apiDelete(`/places/${placeId}/publish`);
}
